export const GA_ID = 'UA-40074367-20';
export const GA_ID_DEV = 'UA-40074367-23';

export const GA4_ID = 'G-H9QMMEQDKX';
export const GA4_ID_DEV = 'G-PDNCGG9PH1';

export const GA_ID_AMP = 'UA-40074367-29';
export const GA_ID_AMP_DEV = 'UA-40074367-28';

export const GA_EVENT_CATEGORY_18 = '18. LINE Mobile 付費';
export const GA_EVENT_CATEGORY_19 = '19. 播放頁改版事件';
